/* global navigator */

define([
  'lib/sumome/service/index',
  'underscore',
  'articles',
  'moment',
  'es6!156085c5-0017-4150-b225-a731ad248f38/service/game/popup',
], (SumoService, _, Articles, moment, GamePopup) => {
  class GameService extends SumoService.Service {
    static SHOWN_COOKIE = '__smGameShown';
    static OPT_OUT_COOKIE = '__smGameOptOut';

    constructor(api, service, popup, opts = {}) {
      super(api);

      if (popup && opts.isPreview) {
        this.popup = new GamePopup(this, {
          ...popup,
          isPreview: true,
        });

        return this.onShow(null, this.popup);
      }

      this.fetchFeatures();

      this.service = service;

      this.showTimeoutId = false;
      this.hasMouse = false;
      this.scrollTop = -1;
      this.lmx = -1;
      this.lmy = -1;
      this.popup = null;

      this.onShow = this.onShow.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseLeave = this.onMouseLeave.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onScroll = this.onScroll.bind(this);

      // Set up cookie functions (list builder needs the Getters for Click Triggers)
      this.setOptOutCookie = service.setOptOutCookie.bind(this, GameService.OPT_OUT_COOKIE);
      this.setShownCookie = service.setShownCookie.bind(this, GameService.SHOWN_COOKIE);
      this.setCtaCookie = service.setCtaCookie.bind(this);
      this.setSubscribedCookie = service.setSubscribedCookie.bind(this);
      this.setPushSubscribedCookie = service.setPushSubscribedCookie.bind(this);

      // If there isn't a popup, then this service is for click triggers.
      if (popup) {
        this.setupPopup(popup);
      }
    }

    setupPopup(popup) {
      this.popup = new GamePopup(this, popup);

      const popupMode = this.popup.settings.get('popup_mode');

      if (popupMode === 'smart') {
        this.showOnExit();
      } else if (popupMode === 'mixed') {
        this.showOnExit();
        this.showOnStartup(this.popup);
      } else {
        this.showOnStartup(this.popup);
      }
    }

    onShow(popupToShow) {
      const popup = popupToShow || this.popup;

      popup.show();
      this.removeAllHandlers();
    }

    onClose() {
      document.documentElement.className = document.documentElement.className.replace(/(listbuilder-popup-open)/g, '');
    }

    onMouseMove(e) {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      const left = document.documentElement.scrollLeft || document.body.scrollLeft;

      this.hasMouse = true;

      // convert to local window position
      this.mx = e.pageX - left;
      this.my = e.pageY - top;

      if (this.lmx > -1) {
        this.travel = (
          Math.max(Math.abs(this.mx - this.lmx), Math.abs(this.my - this.lmy))
          || this.travel
        );
      }

      this.lmx = this.mx;
      this.lmy = this.my;
    }

    onMouseLeave(e) {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      const posy = e.pageY - top;

      if (posy <= 20 && this.travel >= 3) {
        this.onShow();
      }
    }

    onBlur() {
      const posy = this.my;
      const posx = this.mx;
      const width = document.documentElement.clientWidth || document.body.clientWidth;

      if (posy <= 20 && posx >= 20 && posx <= width - 20) {
        this.onShow();
      }
    }

    onScroll() {
      if (this.hasMouse) return;

      const top = document.documentElement.scrollTop || document.body.scrollTop;

      if (this.scrollTop !== false && top < this.scrollTop) {
        this.scrollTop = false;
        this.removeEvent(window, 'scroll', this.onScroll);
        window.setTimeout(() => this.onShow(), 1000);
      }

      this.scrollTop = top;
    }

    showOnStartup(popup) {
      let multiplier = 1000;

      if (popup.settings.get('before_show_delay_interval') === 'minute') multiplier = 1000 * 60;
      this.showTimeoutId = window.setTimeout(() => this.onShow(popup), popup.settings.get('before_show_delay') * multiplier);
    }

    showOnExit() {
      this.addEvent(document, 'mousemove', this.onMouseMove);
      this.addEvent(document, 'mouseleave', this.onMouseLeave);
      this.addEvent(window, 'blur', this.onBlur);

      if ('ontouchstart' in window || !!(navigator.msMaxTouchPoints)) {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        this.addEvent(window, 'scroll', this.onScroll);
      } else {
        this.hasMouse = true;
      }
    }

    removeAllHandlers() {
      this.removeEvent(document, 'mousemove', this.onMouseMove);
      this.removeEvent(document, 'mouseleave', this.onMouseLeave);
      this.removeEvent(window, 'blur', this.onBlur);
      this.removeEvent(window, 'scroll', this.onScroll);

      if (this.showTimeoutId !== false) {
        window.clearTimeout(this.showTimeoutId);

        this.showTimeoutId = false;
      }
    }
  }

  return GameService;
});
